import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d389ad0a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "blank"
};
var _hoisted_2 = {
  key: 0
};
import { useQuestion } from '@/hooks/useQuestion';
import { computed, ref } from 'vue';
import { ErrorCode } from '@/types';
import { nodeList } from '@/utils/answer';
import DTitle from '@/components/DTitle.vue';
import { t } from '@/lang';
export default /*#__PURE__*/_defineComponent({
  __name: 'FillInTheBlank',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var _useQuestion = useQuestion(),
      is_necessary = _useQuestion.is_necessary,
      question_id = _useQuestion.question_id,
      content = _useQuestion.content;
    var max = content.max,
      min = content.min,
      _content$placeholder = content.placeholder,
      placeholder = _content$placeholder === void 0 ? '' : _content$placeholder;
    var placeholderText = computed(function () {
      if (placeholder === '请输入' || placeholder === '') {
        return t().A25();
      }
      return placeholder;
    });
    var answer = ref('');
    var isWarning = computed(function () {
      var _answer$value$length, _answer$value;
      if (!max) return false;
      var len = (_answer$value$length = (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.length) !== null && _answer$value$length !== void 0 ? _answer$value$length : 0;
      return len / max >= 0.9;
    });
    var minText = computed(function () {
      if (min) {
        return t().A6(min);
      }
      return '';
    });
    var node = nodeList.find(question_id);
    if (node) {
      answer.value = node.value.answer;
    }
    __expose({
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(is_necessary && !answer.value)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", {
                  status: false,
                  code: ErrorCode.Necessary
                });
              case 2:
                if (!(min && min > 0 && answer.value.length < min && answer.value.length > 0)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", {
                  status: false,
                  code: ErrorCode.MinText,
                  num: min
                });
              case 4:
                return _context.abrupt("return", {
                  status: true,
                  data: {
                    question_id: question_id,
                    position: [],
                    answer: answer.value
                  }
                });
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function validate() {
          return _validate.apply(this, arguments);
        }
        return validate;
      }()
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(DTitle, {
        "class": "title"
      }, {
        "default": _withCtx(function () {
          return [_unref(min) > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2, " （" + _toDisplayString(minText.value) + "） ", 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createVNode(_component_van_field, {
        modelValue: answer.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return answer.value = $event;
        }),
        modelModifiers: {
          trim: true
        },
        "class": _normalizeClass(["fill-in-the-blank", {
          warning: isWarning.value
        }]),
        type: "textarea",
        maxlength: _unref(max),
        placeholder: placeholderText.value,
        "show-word-limit": ""
      }, null, 8, ["modelValue", "class", "maxlength", "placeholder"])]);
    };
  }
});